import api from "../api/common"
import store from "../store/store"
export default {
    async getUserInfo(){
        let token = store.getters["user/user"];
        console.log(token);
        let type = typeof token;
        if(type != 'string'){
            store.dispatch("user/setUser", null);
            token = '';
            return null;
        }
        let res = await api.rApi('/picUser/picUser/token?token=' + token, {})
        if(res.code == 0){
            return res.picUser;
        }
    }
}


// WEBPACK FOOTER //
// ./src/util/util.js